package horcrux.frontend.collections

import arrow.core.toOption
import horcrux.common.api.dtos.types.CollectionMetadata
import horcrux.common.api.dtos.types.CollectionName
import horcrux.frontend.common.GlobalAppState
import horcrux.frontend.common.clear
import horcrux.frontend.common.get
import horcrux.frontend.common.set
import horcrux.frontend.common.value
import horcrux.frontend.common.views.collections.CollectionMetadataByID
import horcrux.frontend.common.views.collections.collectiondialogs.isInvalidOrNotUnique
import mui.material.AlertColor
import mui.material.Button
import mui.material.Dialog
import mui.material.DialogActions
import mui.material.DialogContent
import mui.material.DialogContentText
import mui.material.FormControlMargin
import mui.material.FormControlVariant
import mui.material.TextField
import react.FC
import react.Props
import react.ReactNode
import react.dom.onChange
import react.router.useNavigate
import react.useState

external interface EditDocumentCollectionNameProps : Props {
    var showDialog: Boolean
    var collectionMetadataByID: CollectionMetadataByID
    var collectionMetadata: CollectionMetadata
    var updateCollectionMetadataByID: (CollectionMetadata) -> Unit
    var closeDialog: () -> Unit

    var globalAppState: GlobalAppState
}

val EditCollectionNameDialog = FC<EditDocumentCollectionNameProps> { props ->
    val newCollectionNameMaybeState = useState<CollectionName?>(null)
    val collectionNameIsInvalid = newCollectionNameMaybeState.isInvalidOrNotUnique(props.collectionMetadataByID)
    val navigate = useNavigate()

    fun closeDialog() {
        newCollectionNameMaybeState.clear()
        props.closeDialog()
    }

    Dialog {
        this.title = "Edit Document Collection Name"
        this.open = props.showDialog
        DialogContent {
            DialogContentText {
                +"Enter a new name for the document collection"
            }
            TextField {
                this.autoFocus = true
                this.margin = FormControlMargin.dense
                this.id = "edit-document-collection-name"
                this.label = ReactNode("Collection Name")
                this.fullWidth = true
                this.variant = FormControlVariant.standard
                this.error = collectionNameIsInvalid
                this.helperText =
                    if (collectionNameIsInvalid) ReactNode("Collection name is invalid or not unique") else null
                this.onChange = {
                    val collectionName = CollectionName(it.value())
                    newCollectionNameMaybeState.set(collectionName)
                }
            }
        }
        DialogActions {
            Button {
                +"Cancel"
                this.onClick = { closeDialog() }
            }
            Button {
                +"Submit"
                this.onClick = {
                    newCollectionNameMaybeState
                        .get()
                        .toOption()
                        .filter { !collectionNameIsInvalid }
                        .map { newCollectionName ->
                            props.globalAppState.submitBackendAPIRequestAsync { backendClient ->
                                backendClient.renameCollection(props.collectionMetadata.id, newCollectionName)
                                    .map {
                                        props.updateCollectionMetadataByID(it.collectionMetadata)
                                        closeDialog()
                                        props.globalAppState.updateBanner(
                                            AlertColor.success,
                                            "Document collection renamed!"
                                        )
                                    }
                                    .bind()
                            }
                        }

                }
            }
        }
    }
}
